import React, { useRef, useState } from 'react';
import Countdown from 'react-countdown';
import toast from 'react-hot-toast';
import PropTypes from 'prop-types';
// import Input from 'components/Input';
// import Mail from 'assets/svgs/mail-icon.svg';
import clsx from 'clsx';
import ForgotPassword from './forgotPassword';
import { useGetOTP, useVerifyOTP } from './manualAuth';
import styles from './VerifyEmail.module.css';
// import './Manual.scss';
import Modal from '../../Modal';

const VerifyEmail = ({ passwordFlow, setPasswordFlow, setShowVerifyEmail }) => {
  const [email, setEmail] = useState('');
  const [showRegister, setShowRegister] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // const privacyPolicyCheck = useSelector(
  //   (state) => state.auth.privacyPolicyCheck
  // );
  const { handleGetOTP } = useGetOTP();

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleEmailOtp = (e) => {
    e.preventDefault();
    // if (!privacyPolicyCheck) {
    //   toast.error('Please check the terms and privacy policy');
    //   return false;
    // }
    if (email === '') toast.error('Email field is empty');
    else {
      const intentForOTP = passwordFlow ? 'forgotPassword' : 'createUser';
      handleGetOTP({ email, intentForOTP, showModal: setShowModal });
    }
  };

  const handleSignInBtn = () => {
    // if (!privacyPolicyCheck) {
    //   toast.error('Please check the terms and privacy policy');
    //   return false;
    // }
    setShowVerifyEmail((p) => !p);
    setPasswordFlow((p) => !p);
  };

  return (
    <>
      {showRegister ? (
        <ForgotPassword email={email} passwordFlow={passwordFlow} />
      ) : (
        <>
          <form onSubmit={handleEmailOtp}>
            <h3 className={styles.VerifyEmail__title}>
              {passwordFlow ? 'Forgot Password' : 'New User'}
            </h3>
            <input
              name="email"
              label="Email Address"
              placeholder="Email Address"
              className={styles.VerifyEmail__input}
              type="email"
              value={email}
              onChange={handleChange}
            />
            <div className="ManualAuth__login-action">
              <input
                disabled={email === ''}
                className={styles['ManualAuth__btn--login']}
                type="submit"
                value={`${passwordFlow ? 'Continue' : 'Verify Email'}`}
              />
            </div>
            <p className={styles['VerifyEmail__forgot-password--prefix-text']}>
              Already have an account?{' '}
              <input
                type="button"
                onClick={handleSignInBtn}
                value="Sign in"
                id={styles['button-link']}
              />
              {/* <a
                className={styles['VerifyEmail__forgot-password']}
                onClick={handleSignInBtn}
              >
                Sign in
              </a> */}
            </p>
          </form>
          {showModal && (
            <EmailOtpModal
              email={email}
              passwordFlow={passwordFlow}
              showModal={setShowModal}
              setShowRegister={setShowRegister}
            />
          )}
        </>
      )}
    </>
  );
};

VerifyEmail.propTypes = {
  passwordFlow: PropTypes.node.isRequired,
  setPasswordFlow: PropTypes.node.isRequired,
  setShowVerifyEmail: PropTypes.node.isRequired,
};

const EmailOtpModal = ({ email, passwordFlow, showModal, setShowRegister }) => {
  const [timer, setTimer] = useState(Date.now() + 600 * 1000);
  const key = useRef(Math.random());
  const { handleGetOTP } = useGetOTP();

  const handleReset = () => {
    const intentForOTP = 'resend';
    handleGetOTP({ email, intentForOTP, showModal });
    setTimer(Date.now() + 600 * 1000);
    key.current = Math.random();
  };

  const renderer = ({ formatted }) => {
    const { minutes, seconds } = formatted;

    return (
      <h4 className={styles.EmailOtp__timer}>
        {minutes}:{seconds}
      </h4>
    );
  };

  return (
    <Modal setShowModal={showModal} isOtp>
      <p className={styles.EmailOtp__email}>{email}</p>
      <Countdown key={key.current} date={timer} autoStart renderer={renderer} />
      <h2 className={styles['EmailOtp__helper-text']}>
        Please check your email (including spam) for One Time Password
      </h2>
      <OtpTextField
        setShowRegister={setShowRegister}
        showModal={showModal}
        email={email}
        passwordFlow={passwordFlow}
      />
      <p className={styles['EmailOtp__recieve-text']}>
        Did not Recieve?
        <button
          type="button"
          className={styles['EmailOtp__resend-text']}
          onClick={handleReset}
        >
          Resend OTP
        </button>
      </p>
      <a
        className={styles.EmailOtp__terms}
        href="mailto:support@fewcents.co"
        target="_blank"
        rel="noreferrer"
      >
        Email Support
      </a>
    </Modal>
  );
};

EmailOtpModal.propTypes = {
  passwordFlow: PropTypes.node.isRequired,
  setShowRegister: PropTypes.node.isRequired,
  email: PropTypes.node.isRequired,
  showModal: PropTypes.node.isRequired,
};

const OtpTextField = ({ email, passwordFlow, setShowRegister, showModal }) => {
  const numOfFields = 6;
  const [otp, setOtp] = useState({
    otp1: '',
    otp2: '',
    otp3: '',
    otp4: '',
    otp5: '',
    otp6: '',
  });
  // const privacyPolicyCheck = useSelector(
  //   (state) => state.auth.privacyPolicyCheck
  // );
  const { error, handleVerifyOTP } = useVerifyOTP();

  const handleChange = (e) => {
    e.preventDefault();
    const { value, name } = e.target;
    const [, fieldIndex] = name.split('-');

    // console.log(parseInt(value));
    // eslint-disable-next-line radix
    if (Number.isNaN(parseInt(value))) {
      setOtp({
        ...otp,
        [`otp${fieldIndex}`]: '',
      });
      return;
    }

    setOtp({
      ...otp,
      [`otp${fieldIndex}`]: value,
    });
  };

  const prevFocus = (index) => {
    if (index > 0) {
      const prevSibling = document.querySelector(
        `input[name=otp-${index - 1}]`
      );

      if (prevSibling !== null) {
        prevSibling.focus();
      }
    }
  };

  const nextFoucs = (index) => {
    if (index < numOfFields) {
      const nextSibling = document.querySelector(
        `input[name=otp-${index + 1}]`
      );

      if (nextSibling !== null) {
        nextSibling.focus();
      }
    }
  };

  const handleKeyUp = (e) => {
    const { name, value } = e.target;
    const [, fieldIndex] = name.split('-');

    // console.log(parseInt(value));

    const idx = parseInt(fieldIndex, 10);

    if (e.key === 'Backspace') {
      prevFocus(idx);
    } else {
      // eslint-disable-next-line radix
      if (Number.isNaN(parseInt(value))) return;
      nextFoucs(idx);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (!privacyPolicyCheck) {
    //   toast.error('Please check the terms and privacy policy');
    //   return false;
    // }
    const { otp1, otp2, otp3, otp4, otp5, otp6 } = otp;
    const data = {
      email,
      code: `${otp1}${otp2}${otp3}${otp4}${otp5}${otp6}`,
    };
    handleVerifyOTP({ data, setShowRegister, showModal, passwordFlow });
  };

  return (
    <form className={styles.OtpTextField} onSubmit={handleSubmit}>
      <div className={styles['OtpTextField__input-container']}>
        <input
          type="text"
          maxLength={1}
          name="otp-1"
          autoComplete="new-password"
          inputMode="numeric"
          className={clsx(
            styles.OtpTextField__input,
            error === 'Incorrect OTP' && styles['OtpTextField__input--error']
          )}
          value={otp.otp1}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
        />
        <input
          type="text"
          maxLength={1}
          name="otp-2"
          autoComplete="new-password"
          inputMode="numeric"
          className={clsx(
            styles.OtpTextField__input,
            error === 'Incorrect OTP' && styles['OtpTextField__input--error']
          )}
          value={otp.otp2}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
        />
        <input
          type="text"
          maxLength={1}
          name="otp-3"
          autoComplete="new-password"
          inputMode="numeric"
          className={clsx(
            styles.OtpTextField__input,
            error === 'Incorrect OTP' && styles['OtpTextField__input--error']
          )}
          value={otp.otp3}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
        />
        <input
          type="text"
          maxLength={1}
          name="otp-4"
          autoComplete="new-password"
          inputMode="numeric"
          className={clsx(
            styles.OtpTextField__input,
            error === 'Incorrect OTP' && styles['OtpTextField__input--error']
          )}
          value={otp.otp4}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
        />
        <input
          type="text"
          maxLength={1}
          name="otp-5"
          autoComplete="new-password"
          inputMode="numeric"
          className={clsx(
            styles.OtpTextField__input,
            error === 'Incorrect OTP' && styles['OtpTextField__input--error']
          )}
          value={otp.otp5}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
        />
        <input
          type="text"
          maxLength={1}
          name="otp-6"
          autoComplete="new-password"
          inputMode="numeric"
          className={clsx(
            styles.OtpTextField__input,
            error === 'Incorrect OTP' && styles['OtpTextField__input--error']
          )}
          value={otp.otp6}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
        />
      </div>
      <input
        type="submit"
        value="Continue"
        className={styles['OtpTextField__continue-btn']}
      />
    </form>
  );
};

OtpTextField.propTypes = {
  passwordFlow: PropTypes.node.isRequired,
  setShowRegister: PropTypes.node.isRequired,
  email: PropTypes.node.isRequired,
  showModal: PropTypes.node.isRequired,
};

export default VerifyEmail;
